import {css} from 'lit';
export const styles = css`:host {
  display: inline-flex;
  align-items: center;
}

a {
  display: flex;
  align-items: center;
}

ef-icon,
img {
  margin-right: 6px;
}

img {
  height: 1em;
}

:host([border]) {
  padding: 8px;
  border: 1px solid var(--border-light-secondary);
  border-radius: var(--border-radius);
}

::slotted(*) {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
`;
export default styles;
